/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateFolderInput = {|
  folderName: string
|};
export type AddFolderMutationVariables = {|
  input: CreateFolderInput
|};
export type AddFolderMutationResponse = {|
  +createFolder: ?{|
    +folderEdge: ?{|
      +cursor: string,
      +node: ?{|
        +id: string,
        +name: ?string,
        +parent: ?{|
          +id: string
        |},
      |},
    |}
  |}
|};
export type AddFolderMutation = {|
  variables: AddFolderMutationVariables,
  response: AddFolderMutationResponse,
|};
*/


/*
mutation AddFolderMutation(
  $input: CreateFolderInput!
) {
  createFolder(input: $input) {
    folderEdge {
      cursor
      node {
        id
        name
        parent {
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateFolderPayload",
    "kind": "LinkedField",
    "name": "createFolder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SubscriptionEdge",
        "kind": "LinkedField",
        "name": "folderEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SubscriptionNode",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddFolderMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddFolderMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "f49e83bf70ab3a38030200ca8726c4b1",
    "id": null,
    "metadata": {},
    "name": "AddFolderMutation",
    "operationKind": "mutation",
    "text": "mutation AddFolderMutation(\n  $input: CreateFolderInput!\n) {\n  createFolder(input: $input) {\n    folderEdge {\n      cursor\n      node {\n        id\n        name\n        parent {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '9672dd368530b77ab11f9f8c86cda534';

module.exports = node;
